module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0